var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMonetizationOnB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 1.66666C5.40008 1.66666 1.66675 5.39999 1.66675 9.99999C1.66675 14.6 5.40008 18.3333 10.0001 18.3333C14.6001 18.3333 18.3334 14.6 18.3334 9.99999C18.3334 5.39999 14.6001 1.66666 10.0001 1.66666ZM11.1751 15.075V16.6667H8.95008V15.0583C7.52508 14.7583 6.31675 13.8417 6.22508 12.225H7.85842C7.94175 13.1 8.54175 13.7833 10.0667 13.7833C11.7001 13.7833 12.0667 12.9667 12.0667 12.4583C12.0667 11.7667 11.7001 11.1167 9.84175 10.675C7.77508 10.175 6.35842 9.32499 6.35842 7.61666C6.35842 6.18332 7.51675 5.24999 8.95008 4.94166V3.33332H11.1751V4.95832C12.7251 5.33332 13.5001 6.50832 13.5501 7.78332H11.9167C11.8751 6.85832 11.3834 6.22499 10.0667 6.22499C8.81675 6.22499 8.06675 6.79166 8.06675 7.59166C8.06675 8.29166 8.60842 8.74999 10.2917 9.18332C11.9751 9.61666 13.7751 10.3417 13.7751 12.4417C13.7667 13.9667 12.6251 14.8 11.1751 15.075Z",
    fill: "#1C1C1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonetizationOnB);
export default __webpack_public_path__ + "static/media/monetization-on_b.a8bc82d137c9ec330cb9cb24e515c554.svg";
export { ForwardRef as ReactComponent };